import { Task, TaskStatus } from "../../types";
import { DreamcoinResponse } from "./types/dreamcoin";

export class DreamcoinSubscribeAdapter {
  static adaptTasks(
    response: DreamcoinResponse,
    statusResponse?: DreamcoinResponse
  ): Task[] {
    console.log("🔄 DreamcoinSubscribeAdapter.adaptTasks - start", {
      response,
      statusResponse,
    });

    if (
      !response ||
      !response.tasks ||
      !Array.isArray(response.tasks) ||
      response.tasks.length === 0
    ) {
      console.log("⚠️ DreamcoinSubscribeAdapter: Нет доступных заданий");
      return [];
    }

    // Фильтруем только задания типа "partner-subscription"
    const subscribeTasks = response.tasks.filter(
      (task) => task.type === "partner-subscription"
    );

    if (subscribeTasks.length === 0) {
      console.log(
        "⚠️ DreamcoinSubscribeAdapter: Нет заданий типа partner-subscription"
      );
      return [];
    }

    return subscribeTasks.map((task) => {
      // Определяем статус задания
      let status: TaskStatus = "NOT_STARTED";

      switch (task.status) {
        case "DONE":
          status = "DONE";
          break;
        case "CLAIMED":
          status = "CLAIMED";
          break;
        case "IN_PROGRESS":
          status = "IN_PROGRESS";
          break;
        case "NOT_STARTED":
        default:
          status = "NOT_STARTED";
      }

      // Если прогресс пользователя равен целевому, но статус не DONE или CLAIMED,
      // устанавливаем статус DONE
      if (task.user_progress >= task.target_progress && status !== "CLAIMED") {
        status = "DONE";
      }

      // Получаем информацию о награде
      const rewardTickets = task.rewards.find(
        (reward) => reward.type === "tickets"
      );
      const rewardDc = task.rewards.find((reward) => reward.type === "dc");

      return {
        id: task.id,
        title: task.name,
        description: task.partner.name,
        icon: task.icon,
        buttonText: "Подписаться",
        rewards: {
          tickets: rewardTickets?.amount || 0,
          dc: rewardDc?.amount || 0,
        },
        status,
        provider: "DREAMCOIN_SUBSCRIBE",
        link: task.partner.link,
        type: "subscribe",
        responseType: task.partner.resource_type,
      };
    });
  }
}
